export default __webpack_public_path__ + "static/media/girl8.0eb26293.jpg";